import * as angular from "angular";
import {PaginatorController} from "./paginator.controller";
const templateUrl = require("./paginator.html");

export const paginator: angular.IDirective = {
    templateUrl: templateUrl,
    controller: PaginatorController,
    controllerAs: "vm",
    bindToController: true,
    scope: {
        oddNumberOfPagesToShow: "=",
        pages: "=",
        currentPage: "=",
        onSetPage: "&"
    }
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/paginator/paginator.ts
 **/